import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

export const HelperLinks = ({ helpers, dark = false, onPick }) => (
  <div className="grid gap-2">
    {helpers.map((h) => (
      <Link key={h.key} to={h.link} onClick={onPick} className={`flex items-center justify-between gap-3 rounded-2xl px-4 py-3 text-left transition-colors ${dark ? "bg-white/10 hover:bg-white/20 text-white" : "bg-white hover:bg-mm-primary/5 text-[#3A2E4F]"}`} data-testid={`moment-helper-${h.key}`}>
        <span className="min-w-0"><span className="font-semibold block">{h.title}</span><span className={`text-xs ${dark ? "text-white/60" : "text-mm-muted"}`}>{h.detail}</span></span>
        <ArrowRight size={16} className="shrink-0" />
      </Link>
    ))}
  </div>
);

// "What usually helps you" from the member's own playbook (hidden if nothing is ready yet)
export const MomentHelpers = ({ dark = false, exclude }) => {
  const [helpers, setHelpers] = useState([]);
  useEffect(() => { if (navigator.onLine) api.get("/playbook/moment", { params: exclude ? { exclude } : {} }).then((r) => setHelpers(r.data.helpers)).catch((e) => logError("Playbook moment failed:", e)); }, [exclude]);
  if (!helpers.length) return null;
  return (
    <div className={`rounded-3xl p-4 text-left mm-fade-up ${dark ? "bg-white/5 border border-white/15" : "bg-[#F3EEFC]"}`} data-testid="moment-helpers">
      <div className={`font-semibold mb-3 ${dark ? "text-white" : ""}`}>🌱 What usually helps you</div>
      <HelperLinks helpers={helpers} dark={dark} />
    </div>
  );
};
